import React, { ReactNode } from "react";
import { Link } from "react-router-dom";
import "../title-bar/styles.css";
import Text from "../typography/text.js";
import StatusIndicatorHeader, {
  StatusType,
} from "../status-indicator/status-indicator.js";
import { useScreen } from "../../components/Utils/Screens.js";

const TitleBar = ({
  entityName,
  entityNameLink,
  label,
  labelTextVariant = "h1",
  invoiceNumber,
  statusIndicatorStatusType,
  statusIndicatorStatus,
  filterBarComponents,
  rightFilterBarComponents,
  titleBarLeftExtra,
  headerBottomExtra,
}) => {
  const isPhone = !useScreen("sm");

  return (
    <div
      className="title-bar-wrapper"
      style={isPhone ? { flexDirection: "column", gap: "16px" } : {}}
    >
      <div
        className={
          isPhone
            ? "title-bar-left-container-phone"
            : "title-bar-left-container"
        }
      >
        <div className="title-bar-header-container">
          {entityNameLink ? (
            <Link to={entityNameLink} className="title-bar-entity-name-link">
              <Text variant="smallText" color="lightText">
                {entityName}
              </Text>
            </Link>
          ) : (
            <Text variant="smallText" color="lightText">
              {entityName}
            </Text>
          )}
          <div className="title-bar-header-bottom-container">
            <Text variant={labelTextVariant}>{label}</Text>
            {invoiceNumber && (
              <Text variant="h1" color="lightText">
                {invoiceNumber}
              </Text>
            )}
            {statusIndicatorStatus && (
              <StatusIndicatorHeader
                status={statusIndicatorStatus}
                statusType={statusIndicatorStatusType}
              />
            )}
            {headerBottomExtra}
          </div>
        </div>
        {titleBarLeftExtra}
        <div
          className={
            isPhone
              ? "title-bar-header-bottom-container-phone"
              : "title-bar-header-bottom-container"
          }
        >
          {filterBarComponents}
        </div>
      </div>
      <div className="title-bar-right-container">
        {rightFilterBarComponents}
      </div>
    </div>
  );
};

export default TitleBar;
